<template>
  <el-main class="main">
    <div class="flex">
      <assistList @select="getstu1" url="/adirector/assistants" />
      <div v-loading="loading" class="neirong">
        <div class="jtitle">
          <h2 class="jtext">查看助教</h2>
        </div>
        <h1 class="sname">{{ tmes.name }}</h1>
        <alistgroup :detail="detail" />
      </div>
    </div>
  </el-main>
</template>

<script>
/* eslint-disable no-console */
import axios from '../axios'
import alistgroup from '../pub/alistgroup'
import assistList from '../pub/assistList'
export default {
  name: 'ADassistant',
  components: {
    alistgroup,
    assistList
  },
  data () {
    return {
      detail: {
        notfinlist: [],
        now_interview: [],
        finlist: [],
        fin_interview: [],
        teacher: {}
      },
      tmes: {},
      loading: true
    }
  },
  methods: {
    getstu1 (tmes) {
      this.loading = true
      axios
        .get(`/${this.$store.state.roleApi}/assistant/${tmes.id}/projects`)
        .then(response => {
          this.tmes = response.data
          this.detail.now_interview = response.data.not_interviewed
          this.detail.notfinlist = response.data.not_finished
          this.detail.finlist = response.data.finished
          this.detail.fin_interview = response.data.interviewed
          this.loading = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
h1 {
  font-size: 30px;
  text-align: left;
  margin-top: 15px;
}
/deep/.jlistgroup {
  height: calc(100vh - 140px);
}
</style>
